import * as i0 from '@angular/core';
import { Directive, Input, HostListener, forwardRef, Component, EventEmitter, Output, HostBinding, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ENTER, SPACE } from '@anthem/uxd/util';

//istanbul ignore next
class CheckboxDirective {
    constructor(_element, _renderer) {
        this._element = _element;
        this._renderer = _renderer;
        this._isChecked = false;
    }
    ngOnInit() {
        //TODO
    }
    /**
     * selector should be placed on input ele
     * runs checks to ensure the requires attributes are set
     * adds class pcOption to input ele
     * adds class pcLabel to label ele
     * if modelValue is set, will check the checkbox that matches the model
     */
    ngAfterViewInit() {
        if (!this._element.nativeElement.id) {
            console.error('CheckboxDirective id missing !!!');
        }
        else if (!this._element.nativeElement.name) {
            console.error('CheckboxDirective name missing !!!');
        }
        if (this._element.nativeElement.nextElementSibling.tagName.toLowerCase() !== 'label') {
            console.error('CheckboxDirective label missing !!!');
        }
        this._renderer.addClass(this._element.nativeElement, 'pcOption');
        this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'pcLabel');
        if (this._modelValue) {
            this.ngOnChanges({ _modelValue: { currentValue: this._modelValue } });
        }
    }
    /**
     * if 'changes['_modelValue'].currentValue' is true set 'this.checked bool' to true
     * adds 'active' class with render to label ele
     * else if 'changes['_modelValue'].currentValue' is false, set isChecked to false
     * removes 'active' class from label ele
     * @param changes - detects changes on dir which is bound through [(ngModel)]
     */
    ngOnChanges(changes) {
        if (typeof changes['_modelValue'] !== 'undefined' && changes['_modelValue'].currentValue) {
            this._isChecked = true;
            if (this._element.nativeElement.nextElementSibling) {
                this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'active');
            }
        }
        else {
            this._isChecked = false;
            if (this._element.nativeElement.nextElementSibling) {
                this._renderer.removeClass(this._element.nativeElement.nextElementSibling, 'active');
            }
        }
    }
    /**
     * binds focus functionality to ele that has dir selector
     */
    onFocus() {
        this._renderer.addClass(this._element.nativeElement, 'active');
        this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'focus');
    }
    /**
     * binds blur functionality to ele that has dir selector
     */
    onBlur() {
        this._renderer.removeClass(this._element.nativeElement, 'active');
        this._renderer.removeClass(this._element.nativeElement.nextElementSibling, 'focus');
    }
    /**
     * binds click functionality to ele that has dir selector
     */
    onClick() {
        this._renderer.addClass(this._element.nativeElement, 'active');
        this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'focus');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckboxDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: CheckboxDirective, selector: "[data-uxd-checkbox-dir]", inputs: { _modelValue: ["ngModel", "_modelValue"] }, host: { listeners: { "focus": "onFocus()", "blur": "onBlur()", "click": "onClick()" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckboxDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[data-uxd-checkbox-dir]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { _modelValue: [{
                type: Input,
                args: ['ngModel']
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

//istanbul ignore next
class CheckboxInputComponent {
    _onChangeCallback(value) {
        // noop
    }
    _onTouchedCallback() {
        // noop
    }
    constructor(_renderer) {
        this._renderer = _renderer;
        this.definition = {
            id: "",
            label: "",
            name: "",
            trueValue: true,
            falseValue: false
        };
        this.optionalAriaLabel = null;
        this.isSelected = false;
        this.isFocused = false;
        this.disabled = false;
    }
    ngAfterViewInit() {
        //noop
    }
    ngOnChanges(changes) {
        //noop
    }
    /**
     * sets 'this.isSelected' to opposite of default value as it is false
     */
    onItemClick() {
        this.isSelected = !this.isSelected;
        this._onChangeCallback(this.isSelected ? this.definition.trueValue : this.definition.falseValue);
    }
    /**
     * adds class focus to label ele
     */
    onItemFocus() {
        this.isFocused = true;
    }
    /**
     * removes class focus from label ele
     */
    onItemBlur() {
        this.isFocused = false;
        this._onTouchedCallback();
    }
    writeValue(v) {
        if (typeof v !== "undefined" &&
            typeof this.definition.trueValue !== "undefined" &&
            typeof this.definition.falseValue !== "undefined" &&
            v !== null &&
            this.definition.trueValue !== null &&
            this.definition.falseValue !== null &&
            v.toString() === this.definition.trueValue.toString()) {
            this.isSelected = true;
        }
        else {
            this.isSelected = false;
        }
    }
    registerOnChange(fn) {
        //todo
        this._onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        //todo
        this._onTouchedCallback = fn;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckboxInputComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CheckboxInputComponent, selector: "[data-uxd-checkbox-input-cmp]", inputs: { definition: "definition", optionalAriaLabel: "optionalAriaLabel", disabled: "disabled" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CheckboxInputComponent),
                multi: true
            }
        ], usesOnChanges: true, ngImport: i0, template: `<input [disabled]="disabled" (focus)="onItemFocus()" (blur)="onItemBlur()" (click)="onItemClick()" [checked]="isSelected" [attr.required]="definition.isRequired ? '' : null" class="pcOption" type="checkbox" [name]="definition.name" [id]="definition.id" [attr.aria-label] = "optionalAriaLabel" />
             <label [class.focus]="isFocused" [class.disabled]="disabled" [id]="'lbl_'+definition.id" [class.active]="isSelected"  class="pcLabel" [attr.for]="definition.id" [innerHTML]="definition.label" [attr.data-analytics] = "definition.analyticsText"></label>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckboxInputComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "[data-uxd-checkbox-input-cmp]",
                    template: `<input [disabled]="disabled" (focus)="onItemFocus()" (blur)="onItemBlur()" (click)="onItemClick()" [checked]="isSelected" [attr.required]="definition.isRequired ? '' : null" class="pcOption" type="checkbox" [name]="definition.name" [id]="definition.id" [attr.aria-label] = "optionalAriaLabel" />
             <label [class.focus]="isFocused" [class.disabled]="disabled" [id]="'lbl_'+definition.id" [class.active]="isSelected"  class="pcLabel" [attr.for]="definition.id" [innerHTML]="definition.label" [attr.data-analytics] = "definition.analyticsText"></label>`,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => CheckboxInputComponent),
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }]; }, propDecorators: { definition: [{
                type: Input
            }], optionalAriaLabel: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

class MultiSelectDirective {
    set checked(isChecked) {
        this._isChecked = isChecked;
    }
    get isChecked() {
        return this._isChecked;
    }
    // tslint:disable-next-line:no-empty
    constructor() {
        this.change = new EventEmitter();
        this._isChecked = false;
    }
    toggle() {
        this._isChecked = !this._isChecked;
        this._emitChangeEvent();
    }
    handleClick(event) {
        this.toggle();
        event.preventDefault();
    }
    handleKeyboard(event) {
        const keyCode = event.keyCode;
        switch (keyCode) {
            case SPACE:
            case ENTER: {
                this.toggle();
                /* BEWARE: button elements will treat SPACE/ENTER as a click event
                 * by default. To prevent this, 'preventDefault' is used.
                 */
                event.preventDefault();
                break;
            }
        }
    }
    _emitChangeEvent() {
        this.change.emit(this._isChecked);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MultiSelectDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: MultiSelectDirective, selector: "[uxd-multi-select]", inputs: { checked: "checked" }, outputs: { change: "change" }, host: { attributes: { "tabindex": "0", "role": "checkbox" }, listeners: { "click": "handleClick($event)", "keydown": "handleKeyboard($event)" }, properties: { "class.is-checked": "this.isChecked", "attr.aria-checked": "this.isChecked", "attr.checked": "this.isChecked" } }, exportAs: ["MultiSelect"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MultiSelectDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: "[uxd-multi-select]",
                    exportAs: "MultiSelect",
                    host: {
                        tabindex: "0",
                        role: "checkbox"
                    }
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { change: [{
                type: Output
            }], checked: [{
                type: Input
            }], isChecked: [{
                type: HostBinding,
                args: ["class.is-checked"]
            }, {
                type: HostBinding,
                args: ["attr.aria-checked"]
            }, {
                type: HostBinding,
                args: ["attr.checked"]
            }], handleClick: [{
                type: HostListener,
                args: ["click", ["$event"]]
            }], handleKeyboard: [{
                type: HostListener,
                args: ["keydown", ["$event"]]
            }] } });

class CheckboxModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CheckboxModule, declarations: [CheckboxDirective, CheckboxInputComponent, MultiSelectDirective], imports: [CommonModule], exports: [CheckboxDirective, CheckboxInputComponent, MultiSelectDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckboxModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [CheckboxDirective, CheckboxInputComponent, MultiSelectDirective],
                    exports: [CheckboxDirective, CheckboxInputComponent, MultiSelectDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CheckboxDirective, CheckboxInputComponent, CheckboxModule, MultiSelectDirective };
